// Canonical vertical taxonomy — FE mirror of ai-receptionist app/services/verticals.py
// (Phase 3 multi-vertical). Keep values in sync with GET /public/verticals.

export const CANONICAL_VERTICALS = ['fnb', 'spa', 'hotel', 'education', 'retail', 'other']

const LEGACY_VERTICAL_MAP = {
    fnb: 'fnb',
    'f&b': 'fnb',
    restaurant: 'fnb',
    cafe: 'fnb',
    bakery: 'fnb',
    spa: 'spa',
    beauty: 'spa',
    'spa & wellness': 'spa',
    wellness: 'spa',
    hotel: 'hotel',
    hospitality: 'hotel',
    education: 'education',
    training: 'education',
    school: 'education',
    retail: 'retail',
    wholesale: 'retail',
    travel: 'other',
    other: 'other',
}

export function normalizeVertical(value, fallback = 'other') {
    if (!value) return fallback
    return LEGACY_VERTICAL_MAP[String(value).trim().toLowerCase()] || fallback
}

// Verticals whose bookings are group/venue-shaped (guests + table/room fields shown)
export function isGuestVenueVertical(vertical) {
    return vertical === 'fnb' || vertical === 'hotel'
}

// Vertical-aware translation resolver.
// vt('bookings.title') tries `verticals.<vertical>.bookings.title` first,
// then falls back to the plain `bookings.title` key — so untouched verticals
// (fnb) and untranslated keys keep today's strings exactly.
export function makeVT(t, vertical) {
    const v = normalizeVertical(vertical, 'fnb')
    return (key, opts = {}) =>
        t(`verticals.${v}.${key}`, { ...opts, defaultValue: t(key, opts) })
}
